module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }, [_c('p', {
    staticClass: "imaged"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/dline.jpg"
    }
  })]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANET")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(". Edited by J. B. Pritchard. 3rd ed. Princeton: Princeton University Press, 1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aq")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aquila’s Greek translation, as documented by F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt.")]), _vm._v(" 2 vols. Oxford: Clarendon, 1867")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ATD")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Das Alte Testament Deutsch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("b.")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(followed by the name of a tractate) Babylonian Talmud")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDB")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Hebrew and English Lexicon of the Old Testament")]), _vm._v(". Francis Brown, S. R. Driver, and C. A. Briggs. Corrected ed. Oxford: Oxford University Press, 1962")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“Librum Proverbiorum.” J. Fichtner. In "), _c('em', [_vm._v("Biblia Hebraica Stuttgartensia: Job et Proverbia")]), _vm._v(". Stuttgart: Württembergische Bibelanstalt, 1974")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CEB")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Common English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTAT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Critique textuelle de l’Ancien Testament Tome 5: Job, Proverbes, Qohélet et Cantique des Cantiques")]), _vm._v(". Dominique Barthélemy. Orbis Biblicus et Orientalis 50/5. Freiburg: Universitätsverlag, 2015")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Classical Hebrew.")]), _vm._v(" Edited by David J. A. Clines et al. 8 vols. Vols. 1–5, Sheffield, UK: Sheffield Academic. Vols. 6–8, Sheffield, UK: Sheffield Phoenix, 1993–2011")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Dead Sea Scrolls Study Edition.")]), _vm._v(" Edited by F. García Martínez and E. J. C. Tigchelaar. 2 vols. Grand Rapids: Eerdmans, 1997–1998")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DTT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Dictionary of the Targumim, the Talmud Babli and Yerushalmi, and the Midrashic Literature.")]), _vm._v(" M. Jastrow. New York: Choreb, 1926")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ESV")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("English Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("EVV")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("English versions (that is, a number of English translations)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HALOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Hebrew and Aramaic Lexicon of the Old Testament")]), _vm._v(". Ludwig Koehler, Walter Baumgartner, et al. Reprint, Leiden: Brill, 2001")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTI")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ketib (“written”) consonantal Masoretic Text")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("KJV")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("King James (Authorized) Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LHBOTS")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Library of the Hebrew Bible/Old Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint Greek translation, as printed in A. Rahlfs, ed., "), _c('em', [_vm._v("Septuaginta")]), _vm._v(", revised by R. Hanhart. Stuttgart: Deutsche Bibelanstalt, 2006")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("m.")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(followed by the name of a tractate) Mishnah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("MG")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Miqra’ot")]), _vm._v(" "), _c('em', [_vm._v("Gedolot")]), _vm._v(", as posted at "), _c('a', {
    attrs: {
      "href": "http://sefaria.org",
      "target": "_blank"
    }
  }, [_vm._v("sefaria.org")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masoretic Text, as printed in "), _c('em', [_vm._v("JPS Hebrew-English Tanakh.")]), _vm._v(" 2nd ed. Philadelphia: Jewish Publication Society, 1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICOT")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PG")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Graeca")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PL")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Latina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Q")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Qere’ (“read out”) Masoretic Text, with vowel markers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sym")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Symmachus’s Greek translation, as documented by F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(". 2 vols. Oxford: Clarendon, 1867")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Theod")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Theodotion’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(". 2 vols. Oxford: Clarendon, 1867")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TOTC")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tyndale Old Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vg")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vulgate Latin translation, as printed in R. Weber, ed., "), _c('em', [_vm._v("Biblia sacra iuxta vulgatam versionem")]), _vm._v(". 3rd ed. Stuttgart: Deutsche Bibelanstalt, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ZBKAT")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zürcher Bibelkommentare: Altes Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("[ ]")])]), _vm._v(" "), _c('td', {
    staticClass: "w60"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Scriptural references printed thus give the chapter and verse reference in printed Hebrew Bibles where their numbering differs from that in English translations. And different editions and translations have varying versifications of the Ten Commandments and thus varying versifications of Exod 20 and Deut 5, also indicated by references such as Exod 20:25[22] or Deut 5:31[28].")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Scriptural and other translations are mine except where otherwise noted.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476262d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbrevation.vue
// module id = 75
// module chunks = 0